import get from 'lodash.get';
function getStatus(statusObject) {
    return statusObject.buyable
        ? 'inStock'
        : statusObject.stockNotificationEnabled
            ? 'notifyWhenBack'
            : 'outOfStock';
}
function StockStatusContainer({ product, children }) {
    const { status, text, maxOrderQuantity, stockDate } = useStockStatus(product);
    if (!status)
        return null;
    // Mimic fn-as-child pattern
    return children({
        status,
        text,
        maxOrderQuantity,
        stockDate
    });
}
function useStockStatus(product) {
    const stockStatus = get(product, 'stockStatus');
    if (!stockStatus) {
        console.warn('The provided product does not have a stockStatus');
        return {
            status: undefined,
            text: undefined,
            maxOrderQuantity: undefined,
            stockDate: undefined
        };
    }
    return {
        status: getStatus(stockStatus),
        text: stockStatus.text,
        maxOrderQuantity: stockStatus.maxOrderQuantity,
        stockDate: stockStatus.stockDate
    };
}
export default StockStatusContainer;
export { useStockStatus };
//# sourceMappingURL=StockStatusContainer.js.map